var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.has_thumbnail
        ? _c(
            "SvgPanZoomThumbnail",
            {
              attrs: {
                onThumbnailShown: _vm.onThumbnailShown,
                mainSPZ: _vm.spz,
                bus: _vm.bus
              }
            },
            [_vm._t("thumbnail")],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }